import { useQuery } from "@tanstack/react-query";
import type { GovernorateView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseGovernoratesQueryParams = {
  storeSlug: string;
};

export function useGovernoratesQuery({ storeSlug }: UseGovernoratesQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.storeGovernorates(storeSlug),
    queryFn: () =>
      apiJsonClient<GovernorateView[]>(endpoints.seller.storeGovernorates, {
        cache: "no-store",
      }),
    enabled: storeSlug.length > 0,
    staleTime: 5 * 60 * 1000, // governorates are reference data, cache for 5 minutes
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
